// 3rd Party
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

// Other
import { StyledFormItem } from 'common/styles/oc-styled-components';

import {
  FloatingStyledInput,
  FloatingStyledTextarea,
  HoldFloat,
  Label,
} from './styled-components';

// Component
const FloatingInput = ({
  field,
  form,
  label,
  message,
  initialValue,
  required,
  testId,
  validator,
  onChange,
  type,
  htmlType,
  capitalize,
  isTextarea,
  error,
  disabled,
  sensitive,
  mask,
}) => {
  const inputRef = useRef(null);
  const [float, setFloat] = useState(!!initialValue);

  useEffect(() => {
    if (initialValue) {
      setFloat(!!initialValue);
    }
  }, [initialValue]);

  const handleFocus = () => {
    setFloat(true);
  };

  const handleBlur = () => {
    // TODO using the form for this is very strange
    // Inputs should have props: value, onChange
    // So the parent component can control the value
    const value = form?.getFieldValue(field) || initialValue;
    if (!value) {
      setFloat(false);
      return;
    }
    setFloat(true);
  };

  const setFocus = (e) => {
    e.preventDefault();
    inputRef.current.focus();
  };

  return (
    <HoldFloat>
      <StyledFormItem
        name={field}
        initialValue={initialValue}
        rules={[
          {
            message,
            required,
            type,
          },
          () => ({
            validator,
          }),
        ]}
        validateTrigger="onSubmit"
      >
        {isTextarea
          ? (
            <FloatingStyledTextarea
              className={`${sensitive && 'sensitive-data'} ${mask && 'fs-mask'}`}
              data-testid={testId}
              id={label}
              onBlur={handleBlur}
              onFocus={handleFocus}
              onChange={onChange}
              ref={inputRef}
            />
          )

          : (
            <FloatingStyledInput
              capitalize={capitalize.toString()}
              type={htmlType || type}
              className={`${sensitive && 'sensitive-data'} ${mask && 'fs-mask'}`}
              data-testid={testId}
              id={label}
              onBlur={handleBlur}
              onFocus={handleFocus}
              onChange={onChange}
              ref={inputRef}
              error={error.toString()}
              disabled={disabled}
            />
          )}
      </StyledFormItem>
      <Label
        data-testid={`${testId}-label`}
        htmlFor={label}
        small={float}
        onClick={setFocus}
      >
        {label}
      </Label>
    </HoldFloat>
  );
};

FloatingInput.defaultProps = {
  initialValue: undefined,
  message: '',
  required: false,
  validator: null,
  onChange: () => {},
  type: null,
  htmlType: null,
  capitalize: true,
  error: false,
  disabled: false,
  sensitive: true,
  mask: false,
};

FloatingInput.propTypes = {
  field: PropTypes.string.isRequired,
  form: PropTypes.object,
  initialValue: PropTypes.string,
  label: PropTypes.string.isRequired,
  message: PropTypes.string,
  required: PropTypes.bool,
  testId: PropTypes.string,
  validator: PropTypes.func,
  onChange: PropTypes.func,
  type: PropTypes.string,
  htmlType: PropTypes.string,
  capitalize: PropTypes.bool,
  isTextarea: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  sensitive: PropTypes.bool,
  mask: PropTypes.bool,
};

export default FloatingInput;
